import React from "react";
import { Outlet } from "react-router-dom";
import AppFooter from "../Components/AppFooter";
import AppHeader from "../Components/AppHeader";
import { noAuthMenuVusa } from "../Utils/constants.api";

export const MainLayout = () => {
  return (
    <>
      <AppHeader
        serviceName="Registro y Seguimiento para Generadores de Residuos de Manejo Especial y Peligrosos"
        noAuthMenu={noAuthMenuVusa}
      />
      <div className="main-container">
        <Outlet />
      </div>
      <AppFooter />
    </>
  );
};
